{
  "fr": {
    "agents": {
      "credentials": {
        "create": {
          "created": "La credential a été ajoutée."
        },
        "destroy": {
          "destroyed": "La credential a été supprimée."
        },
        "update": {
          "updated": "La valeur a été remplacée."
        }
      }
    },
    "api": {
      "v1": {
        "errors": {
          "artifact_not_textual": "Cet artifact n'est pas textuel (%{mime_type}), téléchargez-le via l'API de management.",
          "artifact_too_large": "Cet artifact dépasse 1 Mio, téléchargez-le via l'API de management.",
          "bad_request": "Requête invalide : le membre « data » est requis.",
          "internal_error": "Une erreur interne est survenue.",
          "invalid_api_key": "Clé d'API absente ou invalide.",
          "invalid_include": "Le paramètre « include » est invalide : %{include}.",
          "not_acceptable": "Le type de média JSON:API doit être accepté sans paramètre.",
          "not_found": "Ressource introuvable.",
          "revision_stale": "Le bundle est déjà à la révision %{number}, relisez-le avant de réessayer.",
          "type_mismatch": "Le type de ressource ne correspond pas à ce point d'entrée.",
          "unsupported_media_type": "Le type de média JSON:API ne doit porter aucun paramètre.",
          "workflow_stale": "Ce workflow est déjà à la version %{version}, relisez-le avant de réessayer."
        }
      }
    },
    "api_keys": {
      "create": {
        "created": "La clé API a été créée. Copiez le token maintenant, il ne sera plus affiché."
      },
      "destroy": {
        "revoked": "La clé API a été révoquée."
      }
    },
    "bundles": {
      "create": {
        "created": "Le bundle %{name} a été créé."
      },
      "destroy": {
        "destroyed": "Le bundle %{name} a été supprimé."
      },
      "filters": {
        "all": "Tous",
        "usage": "Utilisation"
      },
      "index": {
        "new": "Nouveau bundle",
        "search": "Rechercher un bundle"
      },
      "new_modal": {
        "description": "Description",
        "name": "Nom",
        "name_hint": "Minuscules, chiffres et tirets. Par exemple deploy-staging.",
        "submit": "Créer le bundle",
        "title": "Nouveau bundle"
      },
      "revisions": {
        "create": {
          "created": "La révision %{number} a été enregistrée."
        },
        "rollbacks": {
          "create": {
            "created": "Restauration effectuée dans la révision %{number}."
          }
        },
        "show": {
          "back_to_editor": "Retour à l'éditeur",
          "restore": "Restaurer cette révision",
          "title": "%{name} · rev %{number}",
          "used_by": {
            "one": "Utilisé par 1 step",
            "other": "Utilisé par %{count} steps",
            "zero": "Aucun usage"
          }
        }
      }
    },
    "components": {
      "action_menu_component": {
        "label": "Autres actions"
      },
      "breadcrumb_component": {
        "label": "Fil d'Ariane"
      },
      "bundles": {
        "diff_viewer_component": {
          "changed_files": "Fichiers changés"
        },
        "editor_component": {
          "cancel": "Annuler",
          "close_tab": "Fermer l'onglet",
          "delete_file": "Supprimer le fichier",
          "delete_file_confirm": "Supprimer le fichier",
          "delete_file_title": "Supprimer ce fichier ?",
          "delete_file_warning": "Le fichier sera retiré du bundle à la prochaine révision enregistrée.",
          "delete_folder": "Supprimer le dossier",
          "delete_folder_confirm": "Supprimer le dossier",
          "delete_folder_title": "Supprimer ce dossier ?",
          "delete_folder_warning": "Le dossier et les fichiers qu'il contient seront retirés du bundle à la prochaine révision enregistrée.",
          "file_actions": "Actions du fichier",
          "files": "Fichiers",
          "folder_actions": "Actions du dossier",
          "invalid_skill": "Skill invalide",
          "leave_confirm": "Quitter sans enregistrer",
          "leave_stay": "Rester sur la page",
          "leave_title": "Quitter sans enregistrer ?",
          "leave_warning": "Vos changements en cours ne sont pas enregistrés. Ils seront perdus si vous quittez cette page.",
          "name_errors": {
            "inside_itself": "Un dossier ne peut pas être déplacé dans lui-même.",
            "invalid": "« %{name} » n'est pas un nom de fichier ou de dossier valide.",
            "not_a_folder": "« %{name} » est un fichier, pas un dossier.",
            "taken": "« %{name} » existe déjà à cet emplacement."
          },
          "name_field": "Nom du fichier ou dossier",
          "new_file": "Nouveau fichier",
          "new_folder": "Nouveau dossier",
          "no_file": "Aucun fichier ouvert",
          "no_file_hint": "Sélectionner un fichier dans l'arborescence, ou en créer un.",
          "no_file_read_only_hint": "Sélectionner un fichier dans l'arborescence pour lire son contenu.",
          "pending_changes": {
            "one": "%{count} changement non enregistré",
            "other": "%{count} changements non enregistrés"
          },
          "placeholders": {
            "file": "fichier.ext",
            "folder": "nom-du-dossier"
          },
          "rename_file": "Renommer le fichier",
          "rename_folder": "Renommer le dossier",
          "resize": "Redimensionner",
          "revision_title": "Enregistrer une révision",
          "runner_variables": {
            "runner_artifacts": "Le dossier où déposer les fichiers à récupérer après le run",
            "runner_event": "Le nom de l'event reçu, vide hors webhook",
            "runner_payload": "Le corps reçu, en JSON",
            "runner_share_url": "Le lien signé public vers la page de review de ce run",
            "runner_step_outputs": "Les sorties des steps précédents, en JSON, indexées par clé",
            "runner_trigger": "Ce qui a déclenché le run : webhook, cron ou manual",
            "runner_workspace": "Le dossier où le bundle a été déposé"
          },
          "save_revision": "Enregistrer la révision",
          "save_revision_disabled": "Message de révision requis",
          "skill": "Skill",
          "skill_warning": "SKILL.md invalide (%{errors}) : le bundle ne sera pas proposé aux steps agent tant que ce n'est pas corrigé.",
          "summary": "Message de révision",
          "summary_placeholder": "Description des changements",
          "used_by": {
            "one": "Ce bundle est utilisé par %{workflows}. Le changement s'appliquera à son prochain run.",
            "other": "Ce bundle est utilisé par %{workflows}. Le changement s'appliquera à leurs prochains runs."
          }
        },
        "editor_modes_component": {
          "changes": "Changements",
          "files": "Fichiers"
        },
        "editor_toolbar_component": {
          "back_to_latest": "Revenir à la dernière révision",
          "delete": "Supprimer le bundle",
          "delete_locked": {
            "one": "Utilisé par le workflow %{workflows}, le retirer de ses steps pour pouvoir supprimer",
            "other": "Utilisé par les workflows %{workflows}, le retirer de leurs steps pour pouvoir supprimer"
          },
          "read_only": "Révision %{number} · lecture seule",
          "save": "Enregistrer",
          "save_disabled": "Aucune modification à enregistrer",
          "used_by": {
            "one": "Utilisé par 1 workflow",
            "other": "Utilisé par %{count} workflows",
            "zero": "Aucun usage"
          }
        },
        "pending_diff_component": {
          "no_change": "Aucun changement en attente.",
          "title": "Changements non enregistrés"
        },
        "revision_diff_component": {
          "compared_to": "comparée à rev %{number}",
          "initial": "révision initiale",
          "no_change": "Aucun changement de contenu dans cette révision.",
          "pinned": {
            "one": "1 step épinglé ici",
            "other": "%{count} steps épinglés ici"
          },
          "revision": "rev %{number}",
          "signature": "%{author} · %{date}",
          "unknown_author": "auteur inconnu"
        },
        "revision_menu_component": {
          "revision": "rev %{number}",
          "see_diff": "Voir le diff",
          "signature": "%{author} · %{date}",
          "title": "Révisions",
          "unknown_author": "auteur inconnu"
        },
        "revision_nav_component": {
          "next": "rev %{number}",
          "no_next": "Révision la plus récente",
          "no_previous": "Première révision du bundle",
          "previous": "rev %{number}"
        },
        "row_component": {
          "files": {
            "one": "1 fichier",
            "other": "%{count} fichiers",
            "zero": "aucun fichier"
          },
          "invalid_skill": "format invalide",
          "revision": "révision %{number}",
          "script": "Script",
          "skill": "Skill",
          "unused": "non utilisé",
          "used_by": {
            "one": "utilisé par 1 workflow",
            "other": "utilisé par %{count} workflows"
          }
        },
        "usage_panel_component": {
          "blank_hint": "Attachez-le à un step depuis la page d'un workflow.",
          "blank_title": "Aucun step n'utilise ce bundle",
          "following": "Suit la dernière (révision %{number})",
          "following_here": "Suit la dernière, donc celle-ci",
          "pinned_elsewhere": "Épinglé sur la révision %{number}",
          "pinned_here": "Épinglé ici",
          "title": "Steps qui utilisent %{name}"
        }
      },
      "copy_field_component": {
        "copied": "Copié",
        "copy": "Copier"
      },
      "delete_modal_component": {
        "title": "Supprimer « %{name} » ?"
      },
      "file_input_component": {
        "blank": "Aucun fichier choisi",
        "browse": "Choisir un fichier"
      },
      "file_tree_entry_component": {
        "dirty": "Modifié"
      },
      "filter_menu_component": {
        "filter": "Filtrer par %{label}",
        "no_result": "Aucun résultat",
        "prefix": "%{label} :"
      },
      "modal_actions_component": {
        "cancel": "Annuler"
      },
      "modal_component": {
        "close": "Fermer"
      },
      "pagination_component": {
        "label": "Pagination",
        "next": "Suivant",
        "previous": "Précédent"
      },
      "runs": {
        "artifact_list_component": {
          "download": "Télécharger",
          "step": "step %{position} · %{name}",
          "title": "Artifacts",
          "view": "Voir"
        },
        "conditions_component": {
          "absent": "(absent)",
          "or": "ou",
          "received": "Reçu au lancement",
          "received_value": "reçu : %{value}",
          "title": "Conditions"
        },
        "log_lines_component": {
          "empty": "Pas encore de logs.",
          "truncated": "L'affichage s'arrête ici, le step a écrit plus que la limite."
        },
        "log_viewer_component": {
          "download": "Télécharger",
          "title": "Logs"
        },
        "row_component": {
          "progress": "%{done}/%{total} steps"
        },
        "sidebar_component": {
          "run": "Run",
          "steps": "Steps",
          "summary": "Résumé"
        },
        "step_component": {
          "bundle": "%{name} · révision %{number}",
          "command": "Commande",
          "depends_on": "Dépend de ce step",
          "model_unknown": "Modèle non rapporté",
          "prompt": "Prompt",
          "skipped": "Passé sans être lancé.",
          "skipped_conditions": "Passé : ses conditions n'étaient pas remplies.",
          "skipped_dependency": "Passé : une dépendance a échoué ou a été passée avant lui.",
          "transcript": "Logs complets",
          "transcript_close": "Fermer",
          "transcript_download": "Télécharger le JSON",
          "transcript_hint": "Le flux brut de l'agent, un événement par ligne. Cliquez pour déplier.",
          "transcript_loading": "Chargement…"
        },
        "steps": {
          "children_component": {
            "awaiting": "Ce step attend la fin des runs qu'il a lancés. Le run reprendra tout seul.",
            "count": {
              "one": "1 run enfant",
              "other": "%{count} runs enfants",
              "zero": "Aucun run enfant"
            },
            "none": "Aucun run lancé pour le moment."
          },
          "decision_component": {
            "approve": "Approuver",
            "approved": "Approuvé par %{user} le %{at}",
            "instructions": "À valider",
            "note_placeholder": "Note (facultatif)",
            "prompt": "Ce run attend votre validation pour continuer.",
            "reject": "Rejeter",
            "reject_confirm": "Rejeter ce gate arrête définitivement le run. Continuer ?",
            "rejected": "Rejeté par %{user} le %{at}"
          },
          "output_component": {
            "title": "Output"
          },
          "question_component": {
            "answer_placeholder": "Votre réponse",
            "answered": "Répondu par %{user} le %{at}",
            "prompt": "Ce run attend votre réponse pour reprendre.",
            "question": "Question de l'agent",
            "send": "Envoyer la réponse"
          }
        },
        "summary_component": {
          "artifacts": "Artifacts",
          "artifacts_count": {
            "one": "1 fichier",
            "other": "%{count} fichiers"
          },
          "booting": "La machine démarre, le premier step suivra dans quelques secondes.",
          "close": "Fermer",
          "consumption": "Consommation",
          "duration": "Durée",
          "headline": "%{status} · %{steps}",
          "launched_by": "Lancé par",
          "none": "—",
          "open_workflow": "Voir le workflow",
          "payload": "Payload déclencheur",
          "started": "Démarré",
          "steps": {
            "one": "%{count} step sur %{total}",
            "other": "%{count} steps sur %{total}"
          },
          "superseded": "Annulé car remplacé par un run plus récent de la même concurrence.",
          "superseded_link": "Voir ce run",
          "trigger": "Déclencheur"
        },
        "timeline_component": {
          "title": "Déroulé"
        },
        "transcript_component": {
          "truncated": "Aperçu tronqué. Le fichier complet fait %{size}, téléchargez-le pour tout lire."
        }
      },
      "search_select_component": {
        "empty": "Aucun résultat",
        "placeholder": "Rechercher…"
      },
      "settings": {
        "api_key_row_component": {
          "active": "Active",
          "revoke": "Révoquer cette clé",
          "revoke_confirm": "Révoquer la clé %{name} ?"
        },
        "credential_row_component": {
          "delete": "Supprimer cette credential",
          "delete_confirm": "Supprimer la credential %{name} ?"
        },
        "global_secret_row_component": {
          "delete": "Supprimer ce secret",
          "delete_confirm": "Supprimer le secret %{key} ?"
        },
        "mcp_server_row_component": {
          "delete": "Supprimer",
          "delete_confirm": "Supprimer le serveur MCP %{name} ?",
          "edit": "Modifier",
          "edit_title": "Modifier %{name}",
          "env_count": {
            "one": "1 variable",
            "other": "%{count} variables"
          },
          "env_hint": "Laissez vide pour conserver les variables actuelles. Remplir remplace tout.",
          "headers_count": {
            "one": "1 header",
            "other": "%{count} headers"
          },
          "headers_hint": "Laissez vide pour conserver les headers actuels. Remplir remplace tout.",
          "icon_hint": "Optionnelle. Sans icône, un monogramme est généré depuis le nom.",
          "save": "Enregistrer"
        },
        "mcp_setup_component": {
          "claude": "Claude Code",
          "claude_manual": "Ou à la main dans le .mcp.json du projet",
          "cli": "Depuis le projet à connecter",
          "codex": "Codex",
          "codex_manual": "Ou à la main dans le config.toml de Codex",
          "token_placeholder": "Remplacez %{placeholder} par une clé API. Une clé n'est lisible qu'à sa création.",
          "token_ready": "La clé créée est incluse ci-dessus. Elle ne sera plus affichée."
        },
        "mcp_tool_component": {
          "no_argument": "Aucun argument.",
          "required": "requis"
        },
        "mcp_tools_component": {
          "bundle": "Bibliothèque (%{count})",
          "credential": "Credentials (%{count})",
          "run": "Runs (%{count})",
          "webhook": "Webhooks (%{count})",
          "workflow": "Workflows (%{count})"
        },
        "nav_component": {
          "access": "Accès externe",
          "agents": "Agents",
          "execution": "Exécution",
          "integration": "Intégration",
          "mcp_servers": "Serveurs MCP",
          "secrets": "Secrets",
          "title": "Sections des réglages"
        },
        "secret_row_component": {
          "new_value": "Nouvelle valeur",
          "replace": "Remplacer la valeur",
          "save": "Enregistrer"
        }
      },
      "sidebar_component": {
        "dark_mode": "Mode sombre",
        "light_mode": "Mode clair",
        "navigation": "Navigation principale",
        "product": "Prism",
        "sections": {
          "bundles": "Bibliothèque",
          "runs": "Runs",
          "settings": "Réglages",
          "webhooks": "Webhooks",
          "workflows": "Workflows"
        },
        "sign_out": "Se déconnecter"
      },
      "tabs_tab_component": {
        "dirty": "Modifié"
      },
      "webhooks": {
        "condition_verdict_component": {
          "no_event": "sans event",
          "nothing_received": "Ce webhook n'a encore rien reçu, il n'y a rien sur quoi essayer.",
          "retained": "Retenue : la dernière réception (%{event}) déclencherait ce workflow."
        },
        "delivery_row_component": {
          "guid": "Référence de l'appel chez l'émetteur :",
          "headers": "Headers reçus",
          "payload": "Payload",
          "query": "Paramètres de l'URL",
          "replay": "Rejouer",
          "triggered": "Workflows déclenchés"
        },
        "row_component": {
          "deliveries": {
            "one": "1 réception",
            "other": "%{count} réceptions",
            "zero": "–"
          },
          "disabled": "Webhook inactif",
          "enabled": "Webhook actif",
          "path": "POST /hooks/%{slug}",
          "subscribers": {
            "one": "1 workflow abonné",
            "other": "%{count} workflows abonnés",
            "zero": "aucun abonné"
          }
        },
        "toolbar_component": {
          "delete": "Supprimer le webhook",
          "delete_locked": {
            "one": "Écouté par le workflow %{workflows}, le retirer de ses déclencheurs pour pouvoir supprimer",
            "other": "Écouté par les workflows %{workflows}, le retirer de leurs déclencheurs pour pouvoir supprimer"
          },
          "save": "Enregistrer",
          "save_disabled": "Aucune modification à enregistrer"
        }
      },
      "workflows": {
        "editor_component": {
          "add_first": "Ajouter un premier nœud",
          "add_input": "Ajouter un paramètre",
          "add_node": "Ajouter un nœud",
          "add_step": "Ajouter un step",
          "add_trigger": "Ajouter un déclencheur",
          "add_variable": "Ajouter une variable",
          "concurrency": "Concurrence",
          "concurrency_hint": "Sérialise les runs de ce workflow. File d'attente fait patienter le nouveau run derrière celui en cours, Annuler le run en cours le remplace aussitôt.",
          "concurrency_key": "Clé de concurrence",
          "concurrency_key_hint": "Facultatif. Un placeholder comme ${{ payload.ref }} sérialise par valeur. Vide, c'est un seul run à la fois pour tout le workflow.",
          "conditions": "Conditions",
          "conditions_and": "et",
          "conditions_hint": "Un objet JSON qui épouse la forme du corps reçu. Survolez un opérateur pour savoir ce qu'il fait, cliquez pour l'insérer.",
          "conditions_or": "ou",
          "connect_after": "Tirer un lien vers un autre step",
          "connect_before": "Tirer un lien depuis un step ou un déclencheur",
          "connect_trigger": "Tirer un lien vers un step que ce déclencheur démarre",
          "cron": "Expression",
          "cron_hint": "Cinq champs séparés par des espaces, par exemple 0 9 * * 1-5.",
          "delete_input": "Supprimer %{key}",
          "delete_link": "Supprimer ce lien",
          "delete_step": "Supprimer %{name}",
          "delete_trigger": "Supprimer ce déclencheur",
          "delete_variable": "Supprimer %{key}",
          "description": "Description",
          "discard": "Tout annuler",
          "events": "Events",
          "events_hint": "Séparés par des virgules. Le joker * accepte toute une famille : prefixe.* retient tous les events qui commencent par prefixe. Laisser vide pour réagir à tous les events de ce webhook.",
          "fit_view": "Ajuster à la vue",
          "input_default_value": "Valeur par défaut",
          "input_hint": "Aide affichée sous le champ",
          "input_key": "Clé",
          "input_kind": "Type",
          "input_label": "Libellé",
          "input_options": "Choix séparés par des virgules",
          "input_required": "Obligatoire",
          "inputs": "Paramètres de lancement",
          "inputs_hint": "Chaque paramètre devient une clé du payload, lisible avec ${{ payload.cle }}.",
          "json_hint": "Les bundles sont désignés par leur nom, ou par {bundle, revision} pour épingler une révision. Les webhooks le sont par leur slug. Les valeurs de variables ne transitent jamais ici.",
          "leave_confirm": "Quitter sans enregistrer",
          "leave_stay": "Rester sur la page",
          "leave_title": "Quitter sans enregistrer ?",
          "leave_warning": "Vos changements en cours ne sont pas enregistrés. Ils seront perdus si vous quittez cette page.",
          "messages": {
            "conditions": "Les conditions doivent être un objet JSON.",
            "conditions_unknown_operator": "Opérateur inconnu : %{operators}.",
            "cron": "Une expression cron compte cinq champs séparés par des espaces.",
            "document_concurrency_not_an_object": "« concurrency » doit être un objet.",
            "document_not_an_object": "Le document doit être un objet JSON.",
            "document_steps_not_an_array": "« steps » doit être un tableau.",
            "document_trigger_unreadable": "Déclencheur %{index} : il faut soit un webhook, soit un cron.",
            "document_triggers_not_an_array": "« on » doit être un tableau.",
            "document_unknown_bundle": "Step %{index} : le bundle « %{name} » n'existe pas.",
            "document_unknown_concurrency_mode": "Mode de concurrence « %{mode} » inconnu.",
            "document_unknown_dependency": "Step %{index} : la dépendance « %{key} » ne correspond à aucun step.",
            "document_unknown_mode": "Step %{index} : mode « %{mode} » inconnu.",
            "document_unknown_trigger_step": "Déclencheur %{index} : « %{key} » ne correspond à aucun step.",
            "document_unknown_webhook": "Le webhook « %{slug} » n'existe pas.",
            "document_unknown_workflow": "Step %{index} : le workflow « %{name} » n'existe pas.",
            "document_unparsable": "JSON invalide : %{message}",
            "input_duplicated": "Deux paramètres portent la même clé.",
            "input_key": "Chaque paramètre doit avoir une clé.",
            "input_key_invalid": "Une clé de paramètre s'écrit en minuscules, chiffres et underscores.",
            "input_label": "Chaque paramètre doit avoir un libellé.",
            "input_options": "Une liste de choix doit proposer au moins un choix.",
            "name": "Le nom est obligatoire.",
            "step_bundle": "Au moins un bundle est obligatoire en mode script.",
            "step_bundle_blank": "Une ligne de bundle est vide : choisis un bundle ou supprime la ligne.",
            "step_bundle_duplicated": "Le même bundle est attaché deux fois à ce step.",
            "step_child_inputs": "Les paramètres doivent former un objet JSON.",
            "step_child_workflow": "Choisis le workflow à appeler.",
            "step_command": "La commande est obligatoire en mode script.",
            "step_each": "« Pour chaque » doit être un seul placeholder, comme ${{ payload.repos }}.",
            "step_key": "La clé est obligatoire.",
            "step_key_duplicated": "Cette clé est déjà utilisée par un autre step.",
            "step_mcp_server_blank": "Une ligne de serveur MCP est vide : choisis un serveur ou supprime la ligne.",
            "step_mcp_server_duplicated": "Un serveur MCP est attaché deux fois au step.",
            "step_mcp_server_exhausted": "Tous les serveurs du registre sont déjà attachés à ce step.",
            "step_name": "Le nom est obligatoire.",
            "step_prompt": "Le prompt est obligatoire en mode agent.",
            "variable_duplicated": "Deux variables portent la même clé.",
            "variable_key": "Chaque variable doit avoir une clé.",
            "webhook": "Choisis le webhook que ce déclencheur écoute."
          },
          "move_link": "Rebrancher ce lien",
          "name": "Nom",
          "new_agent": "Nouvel agent",
          "new_gate": "Nouvelle validation",
          "new_script": "Nouveau script",
          "new_workflow": "Nouveau workflow",
          "no_input": "Aucun paramètre. Le lancement manuel demandera un payload JSON brut.",
          "no_variable": "Aucune variable. Les steps liront celles que tu ajoutes ici.",
          "pan_tool": "Déplacer le canvas",
          "placeholders_hint": "Les placeholders ${{ payload.issue.number }}, ${{ outputs.cle.champ }}, ${{ event }} et ${{ trigger }} sont remplacés à l'exécution.",
          "rehearse": "Essayer sur la dernière réception",
          "resize": "Redimensionner le panneau",
          "save": "Enregistrer",
          "select_tool": "Sélectionner",
          "shortcuts": {
            "clear_selection": "Désélectionner",
            "copy": "Copier la sélection",
            "cut": "Couper la sélection",
            "delete": "Supprimer la sélection",
            "editing": "Édition",
            "fit_view": "Ajuster à la vue",
            "keys": {
              "delete": "Suppr",
              "escape": "Échap",
              "space": "Espace"
            },
            "pan": "Déplacer le canvas (maintenir)",
            "paste": "Coller",
            "redo": "Rétablir",
            "save": "Enregistrer",
            "select_all": "Tout sélectionner",
            "selection": "Sélection",
            "undo": "Annuler",
            "view": "Vue",
            "zoom_in": "Zoomer",
            "zoom_out": "Dézoomer"
          },
          "shortcuts_title": "Raccourcis clavier",
          "step_allow_failures": "Tolérer les échecs",
          "step_allow_failures_hint": "Un run enfant en échec ne fait pas échouer ce step ; les statuts restent dans sa sortie.",
          "step_bundle_add": "Ajouter un bundle",
          "step_bundle_blank": "Choisir un bundle",
          "step_bundle_delete": "Détacher le bundle",
          "step_bundle_open": "Ouvrir le bundle",
          "step_bundle_revision": "Révision du bundle",
          "step_bundles": "Bundles",
          "step_bundles_blank": "Aucun bundle attaché.",
          "step_bundles_hint": "Un Skill est monté dans .claude/skills, les autres bundles sont copiés dans le dossier du step.",
          "step_child_inputs": "Paramètres du workflow appelé",
          "step_child_inputs_declared": "Paramètres attendus : %{inputs} (* obligatoire).",
          "step_child_inputs_free": "Ce workflow ne déclare aucun paramètre : l'objet est transmis tel quel comme payload.",
          "step_child_inputs_hint": "Un objet JSON, une valeur par paramètre. Les placeholders sont remplacés à l'exécution, ${{ item }} vaut l'élément courant du « pour chaque ».",
          "step_child_workflow": "Workflow appelé",
          "step_child_workflow_blank": "Choisir un workflow",
          "step_child_workflow_hint": "Le run attend la fin des runs qu'il lance, puis continue avec leurs résultats dans ${{ outputs.cle.children }}. Un workflow ne peut ni s'appeler lui-même ni former une boucle.",
          "step_command": "Commande",
          "step_conditions_hint": "Évaluées au moment de lancer le step, contre payload, outputs, event et trigger. Non remplies, le step est passé sans faire échouer le run. Vide, le step tourne toujours.",
          "step_count": {
            "one": "%{count} step",
            "other": "%{count} steps"
          },
          "step_credential": "Credential",
          "step_credential_blank": "Choisir une credential",
          "step_credential_hint": "Le compte avec lequel ce step s'exécute.",
          "step_each": "Pour chaque",
          "step_each_hint": "Un placeholder qui désigne une liste, comme ${{ outputs.resolve.repos }} : un run enfant par élément. Vide, un seul run.",
          "step_instructions": "Instructions",
          "step_instructions_hint": "Affichées à la personne qui valide, pour lui dire quoi vérifier.",
          "step_interruptible": "Peut poser une question",
          "step_interruptible_hint": "L'agent peut suspendre le run pour demander une précision, puis reprend avec la réponse.",
          "step_key": "Clé",
          "step_key_hint": "L'identifiant que les steps suivants utilisent pour lire la sortie de celui-ci.",
          "step_mcp_server_add": "Ajouter un serveur MCP",
          "step_mcp_server_blank_option": "Choisir un serveur",
          "step_mcp_server_delete": "Détacher le serveur",
          "step_mcp_servers": "Serveurs MCP",
          "step_mcp_servers_blank": "Aucun serveur MCP attaché.",
          "step_mcp_servers_codex": "Codex annule les appels MCP en headless : passez le step sur Claude.",
          "step_mcp_servers_hint": "L'agent de ce step voit les tools des serveurs attachés. Registre géré dans les réglages.",
          "step_mode": "Mode",
          "step_name": "Nom",
          "step_prompt": "Prompt",
          "step_revision_none": "@aucune",
          "step_revision_open": "Ouvrir le bundle à la révision %{number}",
          "step_revision_option": "@rév. %{number}",
          "steps_title": "Steps",
          "tablist": "Ce que le panneau édite",
          "tabs": {
            "json": "JSON",
            "steps": "Steps",
            "workflow": "Workflow"
          },
          "tidy": "Ranger les nœuds",
          "trigger": "Déclencheur",
          "trigger_card": {
            "cron": {
              "blank": "Aucune expression",
              "detail": "Planification"
            },
            "webhook": {
              "blank": "Aucun webhook choisi",
              "detail": "Webhook"
            }
          },
          "trigger_count": {
            "one": "%{count} déclencheur",
            "other": "%{count} déclencheurs",
            "zero": "manuel"
          },
          "trigger_name": "Nom",
          "trigger_name_hint": "Facultatif. Sert à reconnaître ce déclencheur quand plusieurs écoutent le même event.",
          "trigger_name_placeholder": "commande /review",
          "triggers_title": "Déclencheurs",
          "unnamed": "Sans nom",
          "unsaved": "Non enregistré",
          "variable_every_step": "Tous les steps",
          "variable_key": "Clé",
          "variable_step_key": "Steps qui peuvent lire cette variable",
          "variable_unchanged": "Inchangée",
          "variable_value": "Valeur de %{key}",
          "variables": "Variables d'environnement",
          "variables_hint": "Les valeurs ne sont jamais réaffichées ni exportées dans le JSON. Laisse vide pour conserver l'actuelle. Le troisième champ réserve une variable à certains steps, séparés par des virgules : un token d'écriture n'a rien à faire dans l'environnement d'un step agent qui lit une donnée externe.",
          "webhook": "Webhook",
          "webhook_blank": "Choisir un webhook",
          "zoom_in": "Zoomer",
          "zoom_out": "Dézoomer"
        },
        "row_component": {
          "disabled": "Inactif",
          "more": {
            "one": "+%{count} autre",
            "other": "+%{count} autres"
          }
        },
        "run_history_component": {
          "bar": "%{status} · %{time}",
          "summary": {
            "one": "Dernier run : %{statuses}",
            "other": "%{count} derniers runs, du plus ancien au plus récent : %{statuses}"
          }
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        null,
        "jan.",
        "fév.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "environ une heure",
          "other": "environ %{count} heures"
        },
        "about_x_months": {
          "one": "environ un mois",
          "other": "environ %{count} mois"
        },
        "about_x_years": {
          "one": "environ un an",
          "other": "environ %{count} ans"
        },
        "almost_x_years": {
          "one": "presque un an",
          "other": "presque %{count} ans"
        },
        "half_a_minute": "une demi‑minute",
        "less_than_x_minutes": {
          "one": "moins d'une minute",
          "other": "moins de %{count} minutes",
          "zero": "moins d'une minute"
        },
        "less_than_x_seconds": {
          "one": "moins d'une seconde",
          "other": "moins de %{count} secondes",
          "zero": "moins d'une seconde"
        },
        "over_x_years": {
          "one": "plus d'un an",
          "other": "plus de %{count} ans"
        },
        "x_days": {
          "one": "%{count} jour",
          "other": "%{count} jours"
        },
        "x_minutes": {
          "one": "%{count} minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "%{count} mois",
          "other": "%{count} mois"
        },
        "x_seconds": {
          "one": "%{count} seconde",
          "other": "%{count} secondes"
        },
        "x_years": {
          "one": "%{count} an",
          "other": "%{count} ans"
        }
      },
      "prompts": {
        "day": "Jour",
        "hour": "Heure",
        "minute": "Minute",
        "month": "Mois",
        "second": "Seconde",
        "year": "Année"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Votre compte a été confirmé avec succès.",
        "send_instructions": "Vous allez recevoir un e-mail avec les instructions nécessaires à la confirmation de votre compte dans quelques minutes.",
        "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez bientôt recevoir un e-mail contenant les instructions de confirmation de votre compte."
      },
      "failure": {
        "already_authenticated": "Vous êtes déjà connecté",
        "inactive": "Votre compte n'est pas encore activé.",
        "invalid": "%{authentication_keys} ou mot de passe incorrect.",
        "invalid_with_attempts": "%{authentication_keys} ou mot de passe incorrect, veuillez réessayer. Tentative %{attempts}/3",
        "last_attempt": "Vous avez droit à une tentative avant que votre compte ne soit verrouillé.",
        "locked": "Votre compte est verrouillé.",
        "locked_for_time": "Votre compte est bloqué pendant %{time}. Veuillez réessayer de vous connecter ultérieurement.",
        "locked_forever": "Votre compte est désactivé. Veuillez contacter le support de %{platform_name} à %{support_email} pour plus d'informations.",
        "not_found_in_database": "%{authentication_keys} ou mot de passe incorrect.",
        "timeout": "Votre session est expirée. Veuillez vous reconnecter pour continuer.",
        "unauthenticated": "Vous devez vous connecter ou vous inscrire pour continuer.",
        "unconfirmed": "Vous devez confirmer votre compte pour continuer."
      },
      "mailer": {
        "confirmation_instructions": {
          "subject": "Instructions de confirmation"
        },
        "reset_password_instructions": {
          "subject": "Instructions pour changer le mot de passe"
        },
        "unlock_instructions": {
          "subject": "Instructions pour déverrouiller le compte"
        }
      },
      "omniauth_callbacks": {
        "failure": "Nous n'avons pas pu vous authentifier via %{kind} : '%{reason}'.",
        "success": "Authentifié avec succès via %{kind}."
      },
      "passwords": {
        "no_token": "Vous ne pouvez accéder à cette page sans passer par un e-mail de réinitialisation de mot de passe. Si vous êtes passé par un e-mail de ce type, assurez-vous d'utiliser l'URL complète.",
        "send_instructions": "Vous allez recevoir les instructions de réinitialisation du mot de passe dans quelques instants",
        "send_paranoid_instructions": "Si votre e-mail existe dans notre base de données, vous allez recevoir un lien de réinitialisation par e-mail",
        "updated": "Votre mot de passe a été édité avec succès, vous êtes maintenant connecté",
        "updated_not_active": "Votre mot de passe a été changé avec succès."
      },
      "registrations": {
        "destroyed": "Votre compte a été supprimé avec succès. Nous espérons vous revoir bientôt.",
        "signed_in": "Connecté avec succès.",
        "signed_up": "Bienvenue, vous êtes connecté.",
        "signed_up_but_inactive": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte n'est pas encore activé.",
        "signed_up_but_locked": "Vous êtes bien enregistré. Vous ne pouvez cependant pas vous connecter car votre compte est verrouillé.",
        "signed_up_but_unconfirmed": "Un message contenant un lien de confirmation a été envoyé à votre adresse email. Ouvrez ce lien pour confirmer votre compte.",
        "update_needs_confirmation": "Votre compte a bien été mis à jour mais nous devons vérifier votre nouvelle adresse email. Merci de vérifier vos emails et de cliquer sur le lien de confirmation pour finaliser la validation de votre nouvelle adresse.",
        "updated": "Votre compte a été modifié avec succès."
      },
      "sessions": {
        "already_signed_out": "Déconnecté avec succès.",
        "new": {
          "google": "Continuer avec Google",
          "subtitle": "Utilisez votre compte Google Capsens.",
          "title": "Connexion"
        },
        "signed_in": "Connecté avec succès.",
        "signed_out": "Déconnecté avec succès."
      },
      "unlocks": {
        "send_instructions": "Vous allez recevoir les instructions nécessaires au déverrouillage de votre compte dans quelques instants",
        "send_paranoid_instructions": "Si votre compte existe, vous allez bientôt recevoir un email contenant les instructions pour le déverrouiller.",
        "unlocked": "Votre compte a été déverrouillé avec succès, veuillez vous connecter pour continuer."
      }
    },
    "enumerize": {
      "agents/credential": {
        "kind": {
          "api_key": "Clé API",
          "oauth": "Token OAuth"
        },
        "provider": {
          "claude": "Claude",
          "codex": "Codex"
        },
        "status": {
          "active": "Active",
          "revoked": "Révoquée"
        }
      },
      "mcp_server": {
        "transport": {
          "http": "HTTP",
          "stdio": "stdio"
        }
      },
      "run": {
        "concurrency_mode": {
          "cancel": "Annuler le run en cours",
          "off": "Désactivée",
          "queue": "File d'attente"
        },
        "status": {
          "awaiting_approval": "En attente de validation",
          "canceled": "Annulé",
          "failed": "Échoué",
          "halted": "Arrêté",
          "queued": "En attente",
          "rejected": "Rejeté",
          "running": "En cours",
          "succeeded": "Réussi",
          "waiting": "En attente (concurrence)"
        },
        "trigger": {
          "cron": "Cron",
          "manual": "Manuel",
          "webhook": "Webhook",
          "workflow": "Workflow"
        }
      },
      "runs/step": {
        "mode": {
          "agent": "Agent",
          "gate": "Validation",
          "script": "Script",
          "workflow": "Workflow"
        },
        "provider": {
          "claude": "Claude",
          "codex": "Codex"
        },
        "status": {
          "awaiting": "En attente de validation",
          "canceled": "Annulé",
          "failed": "Échoué",
          "pending": "En attente",
          "rejected": "Rejeté",
          "running": "En cours",
          "skipped": "Ignoré",
          "succeeded": "Réussi"
        }
      },
      "runs/steps/approval": {
        "decision": {
          "approved": "Approuvé",
          "rejected": "Rejeté"
        }
      },
      "webhook": {
        "event_source": {
          "header": "Dans un header",
          "payload": "Dans le corps"
        },
        "guid_source": {
          "header": "Dans un header",
          "payload": "Dans le corps"
        },
        "signature_encoding": {
          "base64": "Base64",
          "hex": "Hexadécimal"
        },
        "verification_strategy": {
          "hmac_sha256": "HMAC SHA-256",
          "token": "Token secret"
        }
      },
      "webhooks/delivery": {
        "status": {
          "dispatched": "Transmise",
          "pending": "En attente",
          "rejected": "Rejetée",
          "skipped": "Ignorée"
        }
      },
      "workflow": {
        "concurrency_mode": {
          "cancel": "Annuler le run en cours",
          "off": "Désactivée",
          "queue": "File d'attente"
        }
      },
      "workflows/input": {
        "kind": {
          "boolean": "Case à cocher",
          "number": "Nombre",
          "select": "Liste de choix",
          "string": "Texte court",
          "text": "Texte long"
        }
      },
      "workflows/trigger": {
        "kind": {
          "cron": "Cron",
          "webhook": "Webhook"
        }
      }
    },
    "forms": {
      "bundles": {
        "create_revision_form": {
          "stale": "La révision %{number} a été enregistrée par %{author} pendant votre édition. Vos changements sont conservés, relancez l'enregistrement pour les appliquer par-dessus.",
          "unknown_author": "un autre membre"
        }
      }
    },
    "global_secrets": {
      "create": {
        "created": "Le secret global a été ajouté."
      },
      "destroy": {
        "destroyed": "Le secret global a été supprimé."
      },
      "update": {
        "updated": "La valeur a été remplacée."
      }
    },
    "helpers": {
      "bundles": {
        "count": {
          "one": "1 bundle",
          "other": "%{count} bundles",
          "zero": "Aucun bundle"
        },
        "count_filtered": {
          "one": "1 bundle filtré",
          "other": "%{count} bundles filtrés",
          "zero": "Aucun bundle filtré"
        },
        "delete": "Supprimer le bundle",
        "delete_files": {
          "one": "1 fichier",
          "other": "%{count} fichiers",
          "zero": "aucun fichier"
        },
        "delete_revisions": {
          "one": "1 révision",
          "other": "%{count} révisions"
        },
        "delete_warning": "Cette suppression emporte %{revisions} et %{files} de la dernière révision. Elle est définitive.",
        "empty": "Aucun bundle",
        "empty_hint": "Un bundle regroupe les fichiers qu'un step exécute.",
        "no_match": "Aucun bundle",
        "no_match_hint": "Aucun bundle ne correspond à votre recherche.",
        "restore_confirm": "Restaurer la révision %{number} ? Une nouvelle révision sera créée avec son contenu.",
        "restore_locked": "Révision déjà courante",
        "usages": {
          "unused": "Inutilisés",
          "used": "Utilisés"
        }
      },
      "runs": {
        "cancel_confirm": "Annuler ce run ? Le step en cours sera interrompu et les suivants ignorés.",
        "cancel_locked": "Run terminé, plus rien à annuler",
        "count": {
          "one": "1 run",
          "other": "%{count} runs",
          "zero": "Aucun run"
        },
        "count_filtered": {
          "one": "1 run filtré",
          "other": "%{count} runs filtrés",
          "zero": "Aucun run filtré"
        },
        "duration": {
          "hours": "%{hours} h %{minutes} min",
          "minutes": "%{minutes} min %{seconds} s",
          "seconds": "%{count} s"
        },
        "empty": "Aucun run",
        "empty_hint": "Les exécutions de vos workflows apparaîtront ici.",
        "no_match": "Aucun run",
        "no_match_hint": "Aucun run ne correspond à votre recherche.",
        "relaunch_confirm": "Relancer ce workflow avec le même payload ? Un nouveau run sera créé.",
        "relaunch_locked": "Run en cours, relance possible une fois terminé",
        "step_relaunch": "Repartir d'ici",
        "step_relaunch_confirm": "Repartir du step « %{key} » ? Un nouveau run reprend les sorties des steps précédents et rejoue celui-ci ainsi que ceux qui en dépendent.",
        "superseded": "Annulé (remplacé)",
        "usage": {
          "tokens": {
            "one": "%{display} token",
            "other": "%{display} tokens"
          }
        }
      },
      "select": {
        "prompt": "Veuillez sélectionner"
      },
      "submit": {
        "create": "Créer un(e) %{model}",
        "submit": "Enregistrer ce(tte) %{model}",
        "update": "Modifier ce(tte) %{model}"
      },
      "webhooks": {
        "count": {
          "one": "1 webhook",
          "other": "%{count} webhooks",
          "zero": "Aucun webhook"
        },
        "count_filtered": {
          "one": "1 webhook filtré",
          "other": "%{count} webhooks filtrés",
          "zero": "Aucun webhook filtré"
        },
        "delete": "Supprimer le webhook",
        "delete_deliveries": {
          "one": "1 réception",
          "other": "%{count} réceptions",
          "zero": "aucune réception"
        },
        "delete_warning": "L'URL publique cessera de répondre et %{deliveries} du journal seront perdues. Les runs déjà lancés sont conservés. Cette suppression est définitive.",
        "deliveries": {
          "count": {
            "one": "1 réception",
            "other": "%{count} réceptions",
            "zero": "Aucune réception"
          },
          "count_filtered": {
            "one": "1 réception filtrée",
            "other": "%{count} réceptions filtrées",
            "zero": "Aucune réception filtrée"
          },
          "empty": "Aucune réception",
          "empty_hint": "Ce webhook n'a encore rien reçu.",
          "no_match": "Aucune réception",
          "no_match_hint": "Aucune réception ne correspond aux filtres."
        },
        "empty": "Aucun webhook",
        "empty_hint": "Un webhook déclenche un workflow depuis un service externe.",
        "listeners": {
          "disabled": "Workflow inactif",
          "enabled": "Workflow actif",
          "every_event": "Tous les events"
        },
        "no_match": "Aucun webhook",
        "no_match_hint": "Aucun webhook ne correspond à votre recherche.",
        "states": {
          "disabled": "Inactif",
          "enabled": "Actif"
        }
      },
      "workflows": {
        "activation": {
          "activate": "Activer",
          "deactivate": "Désactiver"
        },
        "count": {
          "one": "1 workflow",
          "other": "%{count} workflows",
          "zero": "Aucun workflow"
        },
        "count_filtered": {
          "one": "1 workflow trouvé",
          "other": "%{count} workflows trouvés",
          "zero": "Aucun workflow trouvé"
        },
        "cron": {
          "daily_night": "tous les jours à 02:00",
          "every_ten_minutes": "toutes les 10 minutes",
          "hourly": "toutes les heures",
          "raw": "cron : %{expression}",
          "weekdays_morning": "en semaine à 09:00",
          "weekly_monday": "tous les lundis à 06:00"
        },
        "delete": "Supprimer le workflow",
        "delete_locked": "Appelé par %{workflows} : retirez-le de leurs steps avant de le supprimer.",
        "delete_runs": {
          "one": "1 exécution passée",
          "other": "%{count} exécutions passées",
          "zero": "aucune exécution"
        },
        "delete_steps": {
          "one": "1 step",
          "other": "%{count} steps",
          "zero": "aucun step"
        },
        "delete_warning": "Cette suppression emporte %{steps} et %{runs}. Elle est définitive.",
        "empty": "Aucun workflow",
        "empty_hint": "Un workflow enchaîne des steps déclenchés par webhook, par cron ou à la main.",
        "no_match": "Aucun workflow",
        "no_match_hint": "Aucun workflow ne correspond à cette recherche. Essayez un autre mot ou élargissez les filtres.",
        "operators": {
          "and": "Toutes les conditions listées doivent tenir.",
          "contains": "Contient ce morceau de texte.",
          "containsi": "Contient ce morceau de texte, sans tenir compte de la casse.",
          "endsWith": "Se termine par ce texte.",
          "eq": "Vaut exactement cette valeur.",
          "exist": "Le champ est présent (true) ou absent (false).",
          "gt": "Strictement supérieur, sur un nombre ou un texte.",
          "gte": "Supérieur ou égal, sur un nombre ou un texte.",
          "headers": "Bascule la lecture sur les en-têtes de la réception.",
          "in": "Figure parmi les valeurs listées.",
          "lt": "Strictement inférieur, sur un nombre ou un texte.",
          "lte": "Inférieur ou égal, sur un nombre ou un texte.",
          "neq": "Vaut n'importe quoi sauf cette valeur.",
          "nin": "Ne figure dans aucune des valeurs listées.",
          "not": "Inverse la condition qu'il enveloppe.",
          "or": "Une seule des conditions listées suffit.",
          "query": "Bascule la lecture sur les paramètres de l'URL.",
          "ref": "Désigne un autre champ du corps, pour comparer deux champs entre eux.",
          "startsWith": "Commence par ce texte."
        },
        "states": {
          "disabled": "Inactifs",
          "enabled": "Actifs"
        },
        "status": {
          "active": "Actif",
          "inactive": "Inactif"
        },
        "triggers": {
          "manual": "Manuel"
        }
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      },
      "transliterate": {
        "rule": {
          "À": "A",
          "Â": "A",
          "Æ": "Ae",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Î": "I",
          "Ï": "I",
          "Ô": "O",
          "Ù": "U",
          "Û": "U",
          "Ü": "U",
          "à": "a",
          "â": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "î": "i",
          "ï": "i",
          "ô": "o",
          "ù": "u",
          "û": "u",
          "ü": "u",
          "ÿ": "y",
          "Œ": "Oe",
          "œ": "oe",
          "Ÿ": "Y"
        }
      }
    },
    "layout": {
      "collapse_sidebar": "Replier la barre latérale",
      "expand_sidebar": "Déplier la barre latérale",
      "menu": "Menu",
      "product": "Prism",
      "skip_to_content": "Aller au contenu"
    },
    "layouts": {
      "confirmation": {
        "accept": "Confirmer",
        "cancel": "Annuler",
        "title": "Confirmation"
      }
    },
    "mcp": {
      "errors": {
        "streaming_unsupported": "Ce serveur ne propose pas de flux de notifications en temps réel.",
        "unauthorized": "Clé d'API absente ou invalide."
      }
    },
    "mcp_servers": {
      "create": {
        "created": "Le serveur MCP a été ajouté."
      },
      "destroy": {
        "destroyed": "Le serveur MCP a été supprimé."
      },
      "key_value_rows": {
        "add_env": "Ajouter une variable",
        "add_header": "Ajouter un header",
        "env_key": "Nom de la variable",
        "env_value": "Valeur de la variable",
        "header_key": "Nom du header",
        "header_value": "Valeur du header",
        "remove": "Retirer la ligne"
      },
      "update": {
        "updated": "Le serveur MCP a été mis à jour."
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": " ",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "octet",
              "other": "octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "pundit": {
      "default": "Vous n'êtes pas autorisé à effectuer cette action."
    },
    "runs": {
      "cancellations": {
        "create": {
          "created": "Le run a été annulé."
        }
      },
      "filters": {
        "all": "Tous",
        "status": "Statut",
        "trigger": "Déclencheur",
        "workflow": "Workflow"
      },
      "index": {
        "search": "Rechercher un run"
      },
      "relaunches": {
        "create": {
          "created": "Le run a été relancé.",
          "running": "Impossible de relancer un run qui tourne encore."
        }
      },
      "show": {
        "awaiting_approval": "Ce run est suspendu et attend une intervention. Ouvrez l'étape en attente pour la traiter.",
        "cancel": "Annuler",
        "relaunch": "Relancer"
      },
      "steps": {
        "decisions": {
          "create": {
            "answer": "Réponse envoyée, le run reprend.",
            "approve": "Le gate a été approuvé, le run reprend.",
            "reject": "Le gate a été rejeté, le run est arrêté."
          }
        },
        "relaunches": {
          "create": {
            "created": "Le run repart du step « %{key} », les sorties précédentes sont reprises telles quelles."
          }
        }
      }
    },
    "services": {
      "agents": {
        "credentials": {
          "destroy_service": {
            "credential_referenced": "Cette credential est utilisée par %{workflows}. Choisissez-en une autre sur leurs steps avant de la supprimer."
          }
        }
      },
      "bundles": {
        "create_service": {
          "first_revision": "Création du bundle"
        },
        "destroy_service": {
          "bundle_referenced": "Ce bundle est utilisé par %{workflows}. Retirez-le de leurs steps avant de le supprimer."
        },
        "rollback_service": {
          "revision_already_current": "Cette révision est déjà la révision courante du bundle.",
          "rollback_conflict": "Une révision a été enregistrée entre-temps, la restauration a été annulée. Réessayez.",
          "summary": "Restauration de la révision %{number}"
        },
        "skill_detection_service": {
          "missing_description": "frontmatter : champ « description » manquant ou vide",
          "missing_frontmatter": "frontmatter YAML manquant en tête de SKILL.md (bloc --- … ---)",
          "missing_name": "frontmatter : champ « name » manquant",
          "name_mismatch": "frontmatter : name « %{name} » ≠ nom du bundle « %{bundle_name} »"
        }
      },
      "mcp_servers": {
        "destroy_service": {
          "mcp_server_referenced": "Ce serveur est utilisé par %{workflows}. Retirez-le de leurs steps avant de le supprimer."
        }
      },
      "runs": {
        "cancel_service": {
          "already_over": "Ce run est déjà terminé."
        },
        "conclude_service": {
          "already_over": "Ce run est déjà terminé."
        },
        "create_service": {
          "colliding_bundles": "Le step « %{key} » a deux bundles qui écrivent « %{path} » : %{bundles}.",
          "no_started_step": "Ce déclencheur ne démarre aucun step.",
          "no_step": "Ce workflow n'a aucun step à exécuter."
        },
        "reconcile_service": {
          "exited": "Le runner s'est arrêté sans conclure, code de sortie %{exit_code}.",
          "gate_expired": "Le gate n'a pas été décidé dans le délai imparti.",
          "machine_failed": "La machine n'a pas réussi à démarrer.",
          "machine_gone": "La machine a disparu avant la fin du run.",
          "never_started": "Le run n'a jamais obtenu de machine.",
          "out_of_memory": "La machine a manqué de mémoire.",
          "timed_out": "Le run a dépassé la durée maximale autorisée.",
          "went_silent": "Le runner a cessé de donner signe de vie."
        },
        "start_service": {
          "unavailable": "La machine n'a pas pu être créée : %{error}"
        },
        "steps": {
          "answer_service": {
            "blank": "La réponse ne peut pas être vide.",
            "not_awaiting": "Cette étape n'attend pas de réponse."
          },
          "approve_service": {
            "not_awaiting": "Ce gate n'attend pas de décision."
          },
          "complete_service": {
            "missing_credential": "La credential de ce step n'est plus active."
          },
          "reject_service": {
            "not_awaiting": "Ce gate n'attend pas de décision.",
            "reason": "Rejeté par %{user}.",
            "reason_with_note": "Rejeté par %{user} : %{note}"
          },
          "relaunch_service": {
            "running": "Ce run n'est pas terminé, attendez qu'il s'achève avant de le relancer.",
            "step_gone": "Le workflow ne porte plus de step « %{key} », relancez le run en entier."
          },
          "settle_children_service": {
            "children_failed": {
              "one": "Un run enfant n'a pas réussi : %{runs}.",
              "other": "%{count} runs enfants n'ont pas réussi : %{runs}."
            }
          },
          "spawn_children_service": {
            "child_disabled": "Le workflow appelé « %{name} » est désactivé.",
            "child_empty": "Le workflow appelé « %{name} » n'a aucun step.",
            "child_missing": "Le workflow appelé « %{name} » n'existe plus.",
            "malformed": "Chaque enfant doit porter un item et un objet de paramètres.",
            "not_running": "Ce step n'est pas en cours d'exécution.",
            "run_over": "Ce run est terminé, aucun run enfant ne peut plus être lancé.",
            "too_deep": "Un run ne peut pas en lancer au-delà de %{max} niveaux d'imbrication.",
            "too_many": "Un step ne peut pas lancer plus de %{max} runs enfants (%{count} demandés)."
          }
        }
      },
      "users": {
        "authenticate_from_google_service": {
          "unknown_user": "Aucun compte ne correspond à cette adresse. Contactez un administrateur."
        }
      },
      "webhooks": {
        "destroy_service": {
          "webhook_subscribed": "Ce webhook est écouté par %{workflows}. Retirez-le de leurs déclencheurs avant de le supprimer."
        },
        "dispatch_service": {
          "no_match": "Aucun déclencheur ne retient cette réception.",
          "no_workflow": "Aucun workflow actif n'écoute ce webhook."
        },
        "receive_service": {
          "disabled": "Le webhook est désactivé.",
          "unparsable": "Corps de requête illisible."
        },
        "replay_service": {
          "no_workflow": "Aucun workflow à rejouer pour ce webhook.",
          "rejected": "Une réception rejetée ne se rejoue pas."
        },
        "verify_signature_service": {
          "invalid": "Signature invalide.",
          "missing": "Signature absente.",
          "stale": "Horodatage absent ou hors de la fenêtre de tolérance."
        }
      },
      "workflows": {
        "destroy_service": {
          "workflow_referenced": "Ce workflow est appelé par %{workflows}. Retirez-le de leurs steps avant de le supprimer."
        },
        "environment_variables": {
          "create_service": {
            "key_taken": "Cette clé est déjà utilisée."
          }
        },
        "save_service": {
          "key_conflict": "Une clé de ce workflow vient d'être prise par une autre sauvegarde. Réessayez.",
          "stale": "Ce workflow a été modifié ailleurs depuis que vous l'avez ouvert. Copiez vos changements depuis l'onglet JSON si vous y tenez, puis rechargez la page."
        },
        "triggers": {
          "rehearse_service": {
            "no_event": "Cette réception porte l'event « %{event} », que le déclencheur n'écoute pas.",
            "no_match": "Les conditions ne retiennent pas cette réception."
          }
        }
      }
    },
    "settings": {
      "access": {
        "show": {
          "add_api_key": "Ajouter",
          "api_keys": "Clés API",
          "api_keys_empty_hint": "Une clé permet à un consommateur d'appeler l'API de management.",
          "api_keys_empty_title": "Aucune clé API",
          "api_keys_hint": "Authentifient les consommateurs de l'API de management (runner, skill local, workflow créateur).",
          "description": "Tout ce qui permet à un client extérieur de piloter prism : les clés API, et le serveur MCP que prism expose avec ces mêmes clés.",
          "mcp": "Serveur MCP",
          "mcp_hint": "Expose l'API de management comme outils MCP. Authentifié par une clé API.",
          "mcp_tools": "Voir les outils",
          "setup_hint": "Le setup ci-dessous s'authentifie avec la clé créée au-dessus.",
          "title": "Accès externe",
          "token_reveal": "Nouveau token, copiez-le maintenant. Il ne sera plus affiché."
        }
      },
      "agents": {
        "show": {
          "add_credential": "Ajouter",
          "credentials": "Credentials des providers",
          "description": "Les credentials avec lesquels les steps agentiques s'exécutent dans les machines.",
          "empty_hint": "Un step en mode agent a besoin de la credential active de son provider.",
          "empty_title": "Aucune credential",
          "title": "Agents"
        }
      },
      "mcp_servers": {
        "show": {
          "add_mcp_server": "Ajouter",
          "description": "Le registre des serveurs que les agents consomment : attaché à un step, un serveur donne ses tools à l'agent.",
          "empty_hint": "Un serveur déclaré ici peut être attaché aux steps agentiques des workflows.",
          "empty_title": "Aucun serveur MCP",
          "registry": "Registre",
          "registry_hint": "HTTP distant ou commande stdio exécutée dans la machine.",
          "title": "Serveurs MCP"
        }
      },
      "mcp_tools_modal": {
        "hint": "Les outils qu'un client connecté peut appeler.",
        "title": "Outils MCP"
      },
      "new_api_key_modal": {
        "name": "Nom",
        "name_hint": "Un nom parlant pour identifier le consommateur, par exemple runner-prod ou skill-local.",
        "name_placeholder": "runner-prod",
        "submit": "Créer la clé",
        "title": "Nouvelle clé API"
      },
      "new_credential_modal": {
        "kind": "Type",
        "name": "Nom",
        "name_placeholder": "Claude Max (compte partagé)",
        "provider": "Provider",
        "submit": "Ajouter",
        "title": "Ajouter une credential",
        "value": "Valeur",
        "value_hint": "Chiffrée en base, jamais réaffichée."
      },
      "new_global_secret_modal": {
        "key": "Nom",
        "submit": "Ajouter",
        "title": "Ajouter un secret global",
        "value": "Valeur"
      },
      "new_mcp_server_modal": {
        "command_hint": "Exécutée dans la machine du run. Version pinnée obligatoire pour npx et uvx.",
        "command_placeholder": "npx -y mon-serveur@1.2.3",
        "env_hint": "Chiffrées en base, masquées dans les logs et transcripts des runs.",
        "headers_hint": "Chiffrés en base, masqués dans les logs et transcripts des runs.",
        "icon_hint": "Optionnelle. Sans icône, un monogramme est généré depuis le nom.",
        "name_hint": "Identifiant unique, visible par l'agent comme préfixe de ses tools.",
        "name_placeholder": "prism",
        "submit": "Ajouter",
        "title": "Ajouter un serveur MCP",
        "url_placeholder": "https://exemple.com/mcp"
      },
      "secrets": {
        "show": {
          "add_secret": "Ajouter",
          "description": "Variables d'environnement injectées dans l'environnement de chaque run, tous workflows confondus.",
          "empty_hint": "Une valeur ajoutée ici est lisible par tous les workflows.",
          "empty_title": "Aucun secret global",
          "secrets": "Secrets globaux",
          "secrets_hint": "Une variable de workflow portant le même nom prend le dessus.",
          "title": "Secrets"
        }
      }
    },
    "shared": {
      "runs": {
        "expired": {
          "body": "Ce lien de review n'est plus valide. Demandez une nouvelle review sur la pull request.",
          "title": "Lien expiré ou invalide"
        },
        "show": {
          "empty": "Cette review ne contient encore aucun rapport.",
          "title": "Review · %{workflow}"
        }
      }
    },
    "shrine": {
      "errors": {
        "messages": {
          "extension_exclusion": "a une extension interdite",
          "extension_inclusion": "a une extension non autorisée, les extensions acceptées sont : %{list}",
          "max_size": "est trop lourd, la taille maximale est de %{max_size}",
          "mime_type_exclusion": "a un type interdit",
          "mime_type_inclusion": "a un type non autorisé, les types acceptés sont : %{list}",
          "min_size": "est trop léger, la taille minimale est de %{min_size}"
        }
      }
    },
    "support": {
      "array": {
        "last_word_connector": " et ",
        "two_words_connector": " et ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%d %B %Y %Hh %Mmin %Ss",
        "long": "%A %d %B %Y %Hh%M",
        "short": "%d %b %Hh%M"
      },
      "pm": "pm"
    },
    "users": {
      "omniauth_callbacks": {
        "failure": {
          "authentication_failed": "La connexion avec Google a échoué."
        }
      }
    },
    "webhooks": {
      "create": {
        "created": "Le webhook %{name} a été créé."
      },
      "created_modal": {
        "secret_label": "Secret à recopier chez l'émetteur :",
        "title": "Webhook créé",
        "url_label": "URL à configurer chez l'émetteur :",
        "warning": "Ce secret ne sera plus jamais affiché. À copier maintenant."
      },
      "deliveries": {
        "replays": {
          "create": {
            "created": {
              "one": "La réception a été rejouée, 1 run est parti.",
              "other": "La réception a été rejouée, %{count} runs sont partis."
            }
          }
        },
        "search": "Rechercher un événement, un identifiant",
        "title": "Historique des réceptions"
      },
      "delivery_filters": {
        "all": "Tous",
        "status": "Statut"
      },
      "destroy": {
        "destroyed": "Le webhook %{name} a été supprimé."
      },
      "filters": {
        "all": "Tous",
        "state": "État",
        "strategy": "Vérification"
      },
      "index": {
        "new": "Nouveau webhook",
        "search": "Rechercher un webhook"
      },
      "listeners": {
        "blank_description": "Ajoute un déclencheur sur ce webhook depuis l'éditeur d'un workflow.",
        "blank_title": "Personne n'écoute ce webhook",
        "count": {
          "one": "1 déclencheur",
          "other": "%{count} déclencheurs",
          "zero": "Aucun déclencheur"
        },
        "title": "Workflows à l'écoute"
      },
      "new_modal": {
        "header": "Header portant la signature",
        "header_hint": "Le nom exact du header dans lequel l'émetteur envoie sa signature. Il figure dans sa documentation.",
        "name": "Nom",
        "name_hint": "Le nom du système émetteur, tel que tu le reconnaîtras dans la liste.",
        "strategy": "Vérification de signature",
        "strategy_hints": {
          "hmac_sha256": "Le corps est signé avec le secret partagé, et la signature voyage dans un header.",
          "token": "L'émetteur envoie le secret tel quel dans un header."
        },
        "submit": "Créer le webhook",
        "title": "Nouveau webhook"
      },
      "regenerate_modal": {
        "confirm": "Régénérer le secret",
        "title": "Régénérer le secret ?",
        "warning": "L'ancien secret cessera immédiatement de fonctionner. Les réceptions échoueront tant que le nouveau n'est pas configuré chez l'émetteur."
      },
      "show": {
        "configuration": "Configuration",
        "enabled": "Actif",
        "event_path": "Chemin du nom de l'event",
        "event_path_hint": "Le nom exact du header, ou le chemin dans le JSON reçu, par exemple meta.topic. Laisser vide si l'émetteur ne nomme pas ses events.",
        "event_source": "Emplacement du nom de l'event",
        "event_source_hint": "Chaque émetteur nomme ses events à sa façon : certains dans un header, d'autres dans le corps.",
        "guid_path": "Chemin de l'identifiant de livraison",
        "guid_path_hint": "Le nom exact du header, ou le chemin dans le JSON reçu. Laisser vide si l'émetteur n'identifie pas ses livraisons.",
        "guid_source": "Emplacement de l'identifiant de livraison",
        "guid_source_hint": "Sert à ne pas rejouer deux fois la même livraison. À défaut, une empreinte du corps reçu en tient lieu.",
        "header": "Header portant la signature",
        "name": "Nom",
        "public_url": "URL publique",
        "regenerate": "Régénérer",
        "secret": "Secret",
        "secret_warning": "Il ne sera plus jamais affiché, et les réceptions échoueront tant qu'il n'est pas reporté chez l'émetteur.",
        "signature_encoding": "Encodage de la signature",
        "signature_field": "Champ portant la signature",
        "signature_field_hint": "Quand le header vaut sha256=abc ou t=123,v1=abc, le nom du champ à lire. Laisser vide si le header ne contient que la signature.",
        "signed_payload": "Contenu signé",
        "signed_payload_hint": "Ce sur quoi la signature est calculée. Compose avec ${{ body }} pour le corps reçu, ${{ header.Nom-Du-Header }} pour un header, et ${{ signature.champ }} pour un champ du header de signature.",
        "slug_frozen": "L'URL ne change pas quand le webhook est renommé : elle est déjà configurée chez l'émetteur.",
        "strategy": "Vérification de signature",
        "timestamp_path": "Horodatage signé",
        "timestamp_path_hint": "Où lire l'heure d'émission, avec la même écriture que le contenu signé. Renseigné, il interdit de rejouer une requête capturée. Laisser vide si l'émetteur n'horodate pas.",
        "timestamp_tolerance": "Tolérance en secondes",
        "timestamp_tolerance_hint": "L'écart maximal accepté entre l'horodatage reçu et l'heure du serveur. 300 secondes est l'usage."
      },
      "update": {
        "updated": "Webhook enregistré."
      }
    },
    "workflows": {
      "activations": {
        "create": {
          "created": "Le workflow est actif."
        },
        "destroy": {
          "destroyed": "Le workflow est inactif."
        }
      },
      "create": {
        "created": "Le workflow %{name} a été créé."
      },
      "destroy": {
        "destroyed": "Le workflow %{name} a été supprimé."
      },
      "filters": {
        "all": "Tous",
        "state": "État",
        "trigger_kind": "Déclencheur"
      },
      "index": {
        "new": "Nouveau workflow",
        "search": "Rechercher un workflow"
      },
      "launch_modal": {
        "payload": "Payload d'entrée",
        "payload_hint": "Un objet JSON, transmis aux steps dans RUNNER_PAYLOAD.",
        "submit": "Lancer le run",
        "title": "Lancer un run"
      },
      "new_modal": {
        "description": "Description",
        "description_placeholder": "Ce que fait ce workflow, en une phrase.",
        "name": "Nom",
        "name_hint": "Minuscules, chiffres et tirets. Par exemple sync-trello-cards.",
        "submit": "Créer le workflow",
        "title": "Nouveau workflow"
      },
      "node_choice": {
        "steps": "Step",
        "triggers": "Déclencheur"
      },
      "runs": {
        "create": {
          "created": "Le run a été lancé."
        }
      },
      "show": {
        "launch": "Lancer",
        "runs": "Runs"
      },
      "step_choice": {
        "hints": {
          "agent": "Exécute un prompt",
          "gate": "Met le run en pause pour validation",
          "script": "Exécute une commande",
          "workflow": "Lance un autre workflow et attend ses runs"
        }
      },
      "trigger_choice": {
        "hints": {
          "cron": "Part selon une expression cron",
          "webhook": "Réagit à un appel HTTP entrant"
        }
      },
      "update": {
        "updated": "Le workflow a été enregistré."
      }
    }
  }
}